<template>
    <div class="full-page">
        <div class="container">
            <h1 class="title">Who we are</h1>
            <p>
                Gulf Coast has been transforming the landscape of the Rio Grande Valley of South Texas since 1995, moving
                over 7,700 trees for the Texas Department of Transportation alone.
                It was also the first to utilize large mechanical tree spades, allowing thousands of
                full-sized palms and other trees to be relocated and saved, giving new highways and
                landscapes an instant, established look.
                It has performed a variety of other contracting services since its inception.
                Gulf Coast presently specializes in small to medium size projects, ranging from new construction
                landscaping and erosion control to alterations in existing exterior spaces.
                Gulf Coast concentrates it knowledge and expertise in large tree and palm relocation,
                erosion control, and new landscaping on commercial, state, and municipal projects,
                including private projects.
            </p>
            <br/>
            <div class="columns">
                <div class="column is-9">
                    <h1 class="title">Our Vision</h1>
                    <p>
                        The company’s vision is to protect and prevent the destruction of existing trees and foliage by
                        successfully relocating them using mechanical tree spades. The company believes the
                        landscape around us can be transformed to be aesthetically pleasing, without having to remove the
                        plants from our ecosystem.
                    </p>
                </div>
                <div class="column is-3 has-text-centered">
                    <img src="../assets/content/eps_logo.jpg" style="width: 100%; max-width: 300px;">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'home',
        data () {
            return {}
        }
    }
</script>



// WEBPACK FOOTER //
// Home.vue?28e95d6c